/**
 * @description: 包厢微信登录报表
 * @author: wgt
*/
<template>
	<div class="scan-login-report">
		<div v-show="!showBlacklist" class="list">
			<el-form :inline="true" size="small" :model="list_form">
				<el-form-item label="时间">
					<div class="clearfix" ref="list_date">
						<el-col :span="11">
							<el-input placeholder="开始时间" v-model="list_form.start_date"></el-input>
						</el-col>
						<el-col class="el-line" :span="2">-</el-col>
						<el-col :span="11">
							<el-input placeholder="结束时间" v-model="list_form.end_date"></el-input>
						</el-col>
					</div>
				</el-form-item>
				<el-form-item label="门店">
					<el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop">
						<el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="包厢">
					<el-select v-model="list_form.room_id" filterable clearable placeholder="请选择包厢">
						<el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="微信昵称">
					<el-input placeholder="请输入微信昵称" v-model="list_form.nickname"></el-input>
				</el-form-item>
				<el-form-item label="账单号">
					<el-input placeholder="请输入账单号" v-model="list_form.bill_no"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="blacklistManage">黑名单管理</el-button>
					<el-button type="primary" @click="listQuery">查询</el-button>
					<el-button @click="listExport">导出</el-button>
				</el-form-item>
			</el-form>
			<el-table 
				:data="list_table" 
				v-loading="loading" 
				element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)">
				<el-table-column prop="login_time" label="扫码登录时间"></el-table-column>
				<el-table-column prop="shop_name" label="门店名称"></el-table-column>
				<el-table-column prop="room_name" label="包厢名称"></el-table-column>
				<el-table-column prop="bill_no" label="账单号"></el-table-column>
				<el-table-column prop="nickname" label="微信昵称"></el-table-column>
				<el-table-column prop="headimgurl" label="头像">
					<template slot-scope="scope">
						<img :src="scope.row.headimgurl" alt="头像" class="avatar" />
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="addToBlacklist(scope.row)">加入黑名单</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination 
				background 
				layout="total, prev, pager, next, jumper" 
				:page-size="page_size"
				:current-page.sync="page" 
				:total="list_total" 
				@current-change="getList">
			</el-pagination>
		</div>
		<div v-show="showBlacklist" class="blacklist-manage">
			<h1>黑名单管理</h1>
			<el-input v-model="blacklistNickname" placeholder="请输入微信昵称" class="blacklist-input" size="small" />
			<el-button type="primary" size="small" @click="handleBlacklistSearch">查询</el-button>
			<el-button size="small" @click="showBlacklist = false">返回</el-button>

			<el-table :data="blacklist" v-loading="blacklistLoading" element-loading-text="加载中..." class="blacklist-table">
				<el-table-column prop="create_time" label="加入时间"></el-table-column>
				<el-table-column prop="op_name" label="操作人"></el-table-column>
				<el-table-column prop="nickname" label="微信昵称"></el-table-column>
				<el-table-column prop="headimgurl" label="头像">
					<template slot-scope="scope">
						<img :src="scope.row.headimgurl" alt="头像" class="avatar" />
					</template>
				</el-table-column>
				<el-table-column prop="reason" label="原因"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button v-if="scope.row.status == 1" type="text"
							@click="removeFromBlacklist(scope.row)">移除</el-button>
						<span v-else>({{
							scope.row.status_desc +
							"。操作人：" +
							scope.row.op_remove_name +
							"。操作时间：" +
							scope.row.op_remove_time
						}})</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination 
				background layout="total, prev, pager, next, jumper" 
				:page-size="blacklistPageSize"
				:current-page="blacklistPage" 
				:total="blacklistTotal" 
				@current-change="getBlacklist">
			</el-pagination>
		</div>
		<el-dialog title="提示" :visible.sync="showBlacklistDialog" width="400px" @close="blacklistReason = ''">
			<div class="blacklist-dialog-content">
				确认将"<span class="blacklist-dialog-name">{{ blacklistUser?.nickname
					}}</span>"该用户加入黑名单？确认加入后，该用户将无法使用微信在该门店任一包间微信扫码登录进行点歌/点单等操作！若需恢复，请前往"黑名单管理"进行移除！
			</div>
			<el-input type="textarea" :rows="3" placeholder="请输入加入黑名单原因" v-model="blacklistReason" />
			<span slot="footer" class="dialog-footer">
				<el-button @click="showBlacklistDialog = false">取消</el-button>
				<el-button type="primary" @click="confirmAddBlacklist">确认</el-button>
			</span>
		</el-dialog>
		<el-dialog title="提示" :visible.sync="showRemoveDialog" width="400px">
			<div class="remove-dialog-content">
				确认将"<span class="remove-dialog-name">{{ removeUser?.nickname }}</span>"从黑名单中移除？
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showRemoveDialog = false">取消</el-button>
				<el-button type="primary" @click="confirmRemoveFromBlacklist">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Vue from "vue";
import { Message } from "element-ui";
export default {
	name: "scan-login-report",
	data() {
		return {
			loading: false,
			shop_list: [],
			room_list: [],
			list_form: {
				start_date: "",
				end_date: "",
				shop_id: "",
				room_id: "",
				nickname: "",
				bill_no: "",
			},
			list_table: [],
			page: 1,
			page_size: 15,
			list_total: 0,
			showBlacklist: false,
			blacklist: [], // 黑名单数据
			blacklistLoading: false, // 黑名单加载状态
			blacklistNickname: "", // 黑名单查询用微信昵称
			blacklistPage: 1,
			blacklistPageSize: 15,
			blacklistTotal: 0,
			showBlacklistDialog: false,
			blacklistUser: null,
			blacklistReason: "",
			showRemoveDialog: false, // 添加移除确认弹框显示状态
			removeUser: null, // 添加要移除的用户信息
		};
	},
	mounted() {
		// 初始化时间
		this.list_form.start_date = moment().format("YYYY-MM-DD 00:00");
		this.list_form.end_date = moment().add(1, "day").format("YYYY-MM-DD 00:00");
		this.initDate();
		// 拉取门店和包厢
		this.getShop(() => {
			this.list_form.shop_id = this.shop_list[0]?.id || "";
			this.getRoomList(this.list_form.shop_id);
			this.getList(1);
		});
	},
	methods: {
		initDate() {
			const _this = this;
			$(_this.$refs.list_date).daterangepicker(
				{
					buttonClasses: ["btn btn-default"],
					applyClass: "btn-small btn-orange",
					cancelClass: "btn-small btn-gray",
					startDate: moment().toDate(),
					endDate: moment().add(1, "day").toDate(),
				},
				function (start, end) {
					_this.list_form.start_date = start.format("YYYY-MM-DD 00:00");
					_this.list_form.end_date = end.format("YYYY-MM-DD 00:00");
				}
			);
		},
		// 初始化门店输入框
		getShop: function (resolve) {
			const _this = this;

			Vue.axios
				.post("PublicData/api_getShopListByPurview", {
					header: Vue.request_header,
					request: {
						version: Vue.version,
						param: {},
					},
					comment: "",
				})
				.then((res) => {
					if (res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
						_this.shop_list.shift();
						resolve();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch((err) => {
					layer.msg("出错啦");
				});
		},
		// 获取所有包厢
		getRoomList: function (shop_id) {
			const _this = this;

			Vue.axios
				.post("Shop/getAllRoom", {
					header: Vue.request_header,
					request: {
						version: Vue.version,
						param: {
							shop_id: shop_id,
						},
					},
					comment: "",
				})
				.then((res) => {
					if (res.data.response.result_code == "true") {
						_this.room_list = res.data.response.result;
						_this.room_list.unshift({
							id: "",
							name: "全部",
						});
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch((err) => {
					layer.msg("出错啦");
				});
		},
		changeShop(val) {
			this.list_form.shop_id = val;
			if (val) {
				this.getRoomList(val);
			}
		},
		getList(page) {
			this.loading = true;
			Vue.axios
				.post("RoomWechatLoginLog/getList", {
					header: Vue.request_header,
					request: {
						version: "2.7.16",
						param: {
							shop_id: this.list_form.shop_id,
							start_date: this.list_form.start_date,
							end_date: this.list_form.end_date,
							bill_no: this.list_form.bill_no,
							room_id: this.list_form.room_id,
							nickname: this.list_form.nickname,
							page: page || this.page,
							page_size: this.page_size,
						},
					},
					comment: "",
				})
				.then((res) => {
					console.log(res);
					if (res.data.response.result_code == "true") {
						this.list_table = res.data.response.result.data;
						this.list_total = parseInt(res.data.response.result.count, 10);
					} else {
						layer.msg(res.data.response.error_msg);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		listQuery() {
			this.page = 1;
			this.getList(this.page);
		},
		listExport: function () {
			window.location.href =
				Vue.ctUrl +
				"RoomWechatLoginLog/export" +
				"?start_date=" +
				this.list_form.start_date +
				"&end_date=" +
				this.list_form.end_date +
				"&shop_id=" +
				this.list_form.shop_id +
				"&room_id=" +
				this.list_form.room_id +
				"&bill_no=" +
				this.list_form.bill_no +
				"&nickname=" +
				this.list_form.nickname;
			layer.msg("导出成功！");
		},
		addToBlacklist(row) {
			this.blacklistUser = row;
			this.blacklistReason = "";
			this.showBlacklistDialog = true;
		},
		// 确认加入黑名单
		confirmAddBlacklist() {
			if (this.blacklistUser.is_block == 1) {
				Message.info("该用户已加入黑名单");
				return;
			}
			if (!this.blacklistReason.trim()) {
				Message.warning("请输入加入黑名单原因");
				return;
			}

			Vue.axios
				.post("RoomWechatLoginLog/addBlock", {
					header: Vue.request_header,
					request: {
						version: "2.7.16",
						param: {
							shop_id: this.list_form.shop_id,
							user_id: this.blacklistUser.user_id,
							reason: this.blacklistReason,
						},
					},
					comment: "",
				})
				.then((res) => {
					console.log("res", res);
					if (res.data.response.result_code == "true") {
						layer.msg("加入黑名单成功");
						this.showBlacklistDialog = false;
						this.getList(this.page);
					} else {
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(() => {
					layer.msg("操作失败");
				});
		},
		async getBlacklist(page) {
			this.blacklistLoading = true;
			if (page) this.blacklistPage = page;
			try {
				const res = await Vue.axios.post("RoomWechatLoginLog/getBlockList", {
					header: Vue.request_header,
					request: {
						version: "2.7.16",
						param: {
							shop_id: this.list_form.shop_id,
							nickname: this.blacklistNickname || "",
							page: this.blacklistPage,
							page_size: this.blacklistPageSize,
						},
					},
					comment: "",
				});
				console.log("res", res);
				if (res.data.response.result_code == "true") {
					this.blacklist = res.data.response.result.data;
					this.blacklistTotal =
						parseInt(res.data.response.result.count, 10) || 0;
				} else {
					this.blacklist = [];
					this.blacklistTotal = 0;
					layer.msg(res.data.response.error_msg);
				}
			} catch (e) {
				this.blacklist = [];
				this.blacklistTotal = 0;
				layer.msg("获取黑名单失败");
			}
			this.blacklistLoading = false;
		},
		// 点击黑名单管理按钮
		blacklistManage() {
			this.showBlacklist = true;
			this.blacklistNickname = "";
			this.blacklistPage = 1;
			this.getBlacklist(1);
		},
		// 点击移除按钮
		removeFromBlacklist(row) {
			this.removeUser = row;
			this.showRemoveDialog = true;
		},
		// 确认移除黑名单
		confirmRemoveFromBlacklist() {
			Vue.axios
				.post("RoomWechatLoginLog/removeBlock", {
					header: Vue.request_header,
					request: {
						version: "2.7.16",
						param: {
							id: this.removeUser.id,
						},
					},
					comment: "",
				})
				.then((res) => {
					if (res.data.response.result_code == "true") {
						layer.msg("移除黑名单成功");
						this.showRemoveDialog = false;
						this.getBlacklist(this.blacklistPage);
						this.getList(this.page);
					} else {
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(() => {
					layer.msg("操作失败");
				});
		},
		handleBlacklistSearch() {
			this.blacklistPage = 1;
			this.getBlacklist(1);
		},
	},
};
</script>

<style lang="less" scoped>
.scan-login-report {
	.avatar {
		width: 32px;
		height: 32px;
		border-radius: 50%;
	}

	.blacklist-input {
		width: 200px;
		margin-right: 10px;
	}

	.blacklist-table {
		margin-top: 20px;
	}

	.blacklist-dialog-content {
		color: #f00;
		font-size: 14px;
		margin-bottom: 10px;
	}

	.blacklist-dialog-name,
	.remove-dialog-name {
		color: #000;
	}

	.remove-dialog-content {
		font-size: 14px;
	}
}
</style>
